import type { NetworkData } from '@dynamic-labs-sdk/client';
import { Connection, PublicKey } from '@solana/web3.js';

export const fetchSolBalance = async ({
  address,
  networkData,
}: {
  address: string;
  networkData: NetworkData;
}): Promise<string | null> => {
  // Establish a connection to the Solana network using the provided RPC URL.
  const connection = new Connection(networkData.rpcUrls.http[0]);

  // Convert the string address into a PublicKey object.
  const publicKey = new PublicKey(address);

  // Fetch the balance of the public key. The balance is in lamports.
  const balanceInLamports = await connection.getBalance(publicKey);

  // The getBalance method returns the balance in lamports.
  // 1 SOL = 1,000,000,000 lamports.
  const balanceInSol = balanceInLamports / 1_000_000_000;

  // Return the balance in SOL as a string
  return balanceInSol.toString();
};
